module.exports = __webpack_public_path__ + "static/karla-26c9125f42f422ce44975b7154183407.png";